const courses = [
  {
    id: 1,
    badge: "MODULE 01",
    weeks: "4 Weeks",
    title: "Embedded Systems",
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80",
    description:
      "Master Arduino, ESP32, and STM32 architectures. Learn C++ for hardware and circuit design fundamentals.",
    tags: ["C++ Programming", "Circuit Design"],
  },
  {
    id: 2,
    badge: "MODULE 02",
    weeks: "4 Weeks",
    title: "IoT & Cloud Networking",
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80",
    description:
      "Build secure protocols with MQTT, HTTP, and WebSockets. Integrate hardware with AWS IoT Core and Azure.",
    tags: ["MQTT", "AWS IoT", "Security"],
  },
  {
    id: 3,
    badge: "MODULE 03",
    weeks: "4 Weeks",
    title: "Sensors & Actuators",
    image:
      "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=800&q=80",
    description:
      "Precision control of sensors, stepper motors, and advanced ultrasonic sensor fusion techniques.",
    tags: ["PCB Design", "UART", "Motor Drives"],
  },
  {
    id: 4,
    badge: "MODULE 04",
    weeks: "4 Weeks",
    title: "Robotic Kinematics",
    image:
      "https://images.unsplash.com/photo-1561144257-e32e8efc6c4f?auto=format&fit=crop&w=800&q=80",
    description:
      "Understand mechanical design for robotic arms, mobile robots, and 5-DOF systems.",
    tags: ["ROS", "3D CAD", "Simulation"],
  },
  {
    id: 5,
    badge: "MODULE 05",
    weeks: "4 Weeks",
    title: "Industrial Automation",
    image:
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?auto=format&fit=crop&w=800&q=80",
    description:
      "Learn PLC programming, HMI interfaces, ladder logic, and SCADA systems for modern factory automation.",
    tags: ["PLC", "SCADA", "Industry 4.0"],
  },
  {
    id: 6,
    badge: "MODULE 06",
    weeks: "4 Weeks",
    title: "AI for Robotics",
    image:
      "https://images.unsplash.com/photo-1535378917042-10a22c95931a?auto=format&fit=crop&w=800&q=80",
    description:
      "Computer Vision with OpenCV, ROS2 integration, and autonomous navigation algorithms.",
    tags: ["OpenCV", "ROS2", "Python"],
  },
];

export default function CoursePathway() {
  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <p className="uppercase tracking-[3px] text-xs font-semibold text-black mb-3">
            Course Pathway
          </p>

          <h2 className="text-3xl md:text-5xl  text-[#000D83]">
            Comprehensive Learning Journey
          </h2>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course) => (
            <div
              key={course.id}
              className="bg-white rounded-3xl shadow-sm hover:shadow-xl transition duration-300 overflow-hidden border border-gray-100"
            >
              {/* Image */}
              {course.image ? (
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover"
                />
              ) : (
                <div className="h-48 flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-50 text-5xl text-indigo-600">
                  {course.icon}
                </div>
              )}

              {/* Content */}
              <div className="p-6">
                {/* Badge */}
                <div className="flex items-center gap-2 mb-4">
                  <span className="bg-purple-100 text-purple-700 text-[10px] font-bold px-2 py-1 rounded-full">
                    {course.badge}
                  </span>

                  <span className="text-xs text-gray-400">{course.weeks}</span>
                </div>

                {/* Title */}
                <h3 className="text-xl font-medium text-gray-900 mb-3">
                  {course.title}
                </h3>

                {/* Description */}
                <p className="text-gray-500 text-sm leading-7 mb-6">
                  {course.description}
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-2">
                  {course.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="text-xs bg-gray-100 text-gray-600 px-3 py-1 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
